import React from "react";

import { Stack, Text } from "@/components/ui";

import type { SportNewsArticle } from "@/schemas/sport-news";

const NewsEmbedCard: React.FC<{ article: SportNewsArticle }> = ({
  article,
}) => {
  const image = article.header_image_url;

  return (
    <div className="overflow-hidden rounded-2xl border">
      {image ? (
        <img
          src={image}
          alt=""
          className="aspect-16/9 max-h-50 w-full object-cover"
        />
      ) : (
        <div className="aspect-16/9 max-h-50 w-full bg-gray-200 dark:bg-gray-800" />
      )}

      <Stack space={1} className="px-4 py-3">
        <Text size="md" weight="bold" className="line-clamp-2">
          {article.title}
        </Text>
        {article.summary && (
          <Text size="sm" theme="muted" className="line-clamp-2">
            {article.summary}
          </Text>
        )}
      </Stack>
    </div>
  );
};

export default NewsEmbedCard;
